import React from 'react';

import train from '../../imgs/Train-1.png';
import think1 from '../../imgs/think2.png';

export default class Train1 extends React.Component {
  render() {
    return (<div className='typography-container'>
      <h1>Магнитная левитация</h1>
      <p>
        Если мы поднесем северный полюс постоянного магнита к северному же полюсу другого такого же магнита, магниты будут отталкиваться друг от друга. Этот же принцип — то, что одноименные полюса магнитов отталкиваются, — можно использовать для подъема с земли огромных тяжестей. Поезда на магнитной подвеске проносятся не по путям, а над ними на минимальном расстоянии; на весу их удерживают обычные магниты. Поезда как бы парят в воздухе и могут благодаря нулевому трению развивать рекордные скорости.
      </p>
      <p>
        Первая в мире коммерческая автоматизированная транспортная система на магнитной подвеске была запущена в действие в 1984 г. в британском городе Бирмингеме. Она соединила терминал международного аэропорта и расположенный неподалеку железнодорожный вокзал. Поезда на магнитной подвеске действуют также в Германии, Японии и Корее, хотя большинство из них не предназначены для высоких скоростей. Первый скоростной коммерческий поезд на магнитной подвеске начал ходить по запущенному в действие участку трассы в Шанхае; этот поезд движется по трассе со скоростью до 431 км/ч. Японский поезд на магнитной подвеске в префектуре Яманаси разогнался до скорости 581 км/ч — т. е. двигался значительно быстрее, чем обычные поезда на колесах.
      </p>
      <p align='center'>
        <img src={train} alt="Рис. 3"/>
      </p>
      <p>
        Колеса вагонов поезда на магнитной подушке не соприкасаются с рельсами. Трение происходит только вследствие сопротивления воздуха вагонам мчащегося на подвесе над монорельсом состава. Зазор между поездом и рельсом составляет от 2 до 3 см.
      </p>
      <p>
        Но устройства на магнитной подвеске чрезвычайно дороги. Один из путей к увеличению их эффективности — использование сверхпроводников, которые при охлаждении до температур, близких к абсолютному нулю, полностью теряют электрическое сопротивление.
      </p>

      <img src={think1} />
      <h1>ПОДУМАЙ:</h1>
      <blockquote>
        Почему высокоскоростной поезд движется только прямо или по дуге ОЧЕНЬ большого радиуса?
      </blockquote>
      <p>
        Центробежная сила - это сила, развивающаяся при круговом или криволинейном движении и побуждающая тело оставить кривую, чтоб продолжать свой дальнейший путь по прямой касательной к ней.
      </p>
      <p>
        Центробежная сила направлена от центра кривизны траектории точки и равна: F
        <sub>цб</sub>
        = mv<sup>2</sup>/r, где m - масса материальной точки, v - её скорость, r - радиус кривизны траектории.
      </p>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Train-1.js